import * as Config from '../../config';
import { default as Locale } from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";


export class MaxFillExceeded extends AlertLogic {
    static type = AlertType.MaxBodyOfWaterFillVolume;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_LEVELING ];
    static title = Locale.gettext('Max Fill Exceeded');

    getInfo(alert:AlertRecord = this.alert, config:Config.AllConfig = this.allConfigs):AlertInfo {
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(alert, config);

        // Varying across alert types
        let cardIllustration = 'status_problem';
        let detailIcon = 'water-pump';
        
        let dailyLimit = this.locale.formatVolumeFromGallon(alertData.MaximumDailyRunTimeGallons);
        let dailyAdded = this.locale.formatVolumeFromGallon(alertData.LastDayVolumeInGallons);
        let dailyMinutes = alertData.MaximumDailyRunTime;

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Autofill Disabled'),
            cardDescription: this.locale.gettext('Maximum daily run time has been exceeded'),
            cardIllustration: cardIllustration,
            detailIcon: detailIcon,
            detailDescription: this.locale.gettext('The %1$s autofill has been disabled because the %2$s minute maximum daily run time has been exceeded.',
                body.Name,
                dailyMinutes
            ),
            detailDescription2: this.locale.gettext('If the water is still low, check for a sensor or solenoid malfunction, update the Autofill settings to increase the daily run time, or reach out to your pool professional for assistance.'),
            detailDescription3: this.locale.gettext('The autofill has dispensed %1$s today.', dailyAdded),
            actionButtonTitle: false,
            resolveSummary: this.locale.gettext('%1$s autofill has been enabled', body.Name)
        });
        alertInfo.contentCategories = MaxFillExceeded.contentCategories;
        return alertInfo;
    } 

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord {
        let device = config.Config.Devices.find(dev => dev.DeviceType === "AutoFill");
        let maxFill = (config.BodyOfWaterUserSettings[0]?.BodyOfWaterAutoFillSettings?.FillRateInGpm | 5) * 
                        (config.BodyOfWaterUserSettings[0]?.BodyOfWaterAutoFillSettings?.MaximumDailyRunTimeMinutes | 180);

        return device ? new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, device.UUID, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: device?.UUID,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type: type,
            data: {
                MaximumDailyRunTimeGallons: maxFill,
                LastDayVolumeInGallons: maxFill * 1.1
            }
        }) : null;
    }
}